export default "__VITE_ASSET__DY_6Mei7__"